<script setup lang="ts" generic="T extends RoutesNamesList, P extends string">
import type { HTMLAttributes } from 'vue'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import type { RoutesNamesList, NuxtRoute } from '@typed-router'
import { type ButtonVariants, buttonVariants } from '.'
import { cn } from '@/lib/utils'
import { NuxtLink } from '#components'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  outlined?: ButtonVariants['outlined']
  loading?: boolean
  text?: string
  icon?: string
  iconPosition?: 'left' | 'right'
  href?: string
  to?: NuxtRoute<T, P>
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  outlined: false,
  variant: 'default',
  iconPosition: 'left',
})
</script>

<template>
  <Primitive
    :as="props.to || props.href ? NuxtLink : as"
    :to="props.to"
    :href="props.href"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size, outlined }), props.class)"
    :disabled="props.loading"
  >
    <Icon
      v-if="props.loading"
      name="tabler:loader"
      class="size-4 animate-spin"
    />
    <slot>
      <Icon
        v-if="icon && props.iconPosition === 'left'"
        :name="icon"
        class="size-4"
      />
      {{ text }}
      <Icon
        v-if="icon && props.iconPosition === 'right'"
        :name="icon"
        class="size-4"
      />
    </slot>
  </Primitive>
</template>
